import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const ErrorDialog = ({ history, isLocalCommodity }) => {
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const showError = localStorage.getItem('showErrorDialog');
    const errorTtl = localStorage.getItem('errorTitle');
    const errorMsg = localStorage.getItem('errorMessage');

    if (showError === 'true') {
      setErrorMessage(errorMsg);
      if (errorTtl) {
        setErrorTitle(errorTtl);
      }
      setOpenErrorDialog(true);
    }
  }, []);

  // open dialog
  useEffect(() => {
    const handler = e => {
      const { title, message } = e?.detail || {};
      if (title) setErrorTitle(title);
      if (message) setErrorMessage(message);
      setOpenErrorDialog(true);
    };
    window.addEventListener('openErrorDialog', handler);
    return () => window.removeEventListener('openErrorDialog', handler);
  }, []);

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
    localStorage.setItem('showErrorDialog', 'false');
    localStorage.removeItem('errorTitle');
    localStorage.removeItem('errorMessage');
    setTimeout(() => {
      history.push(`/home`);
    }, 3000);
  };

  const getDialogTitle = () => {
    return isLocalCommodity ? 'Error' : 'Bursa Error';
  };

  return (
    <Dialog open={openErrorDialog} onClose={handleCloseErrorDialog}>
      <DialogTitle style={{ fontWeight: 'bold' }}>{errorTitle || getDialogTitle()}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'black' }} className="mb-3">
          <strong>Error:</strong> {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="mx-3">
        <Button color="primary" onClick={handleCloseErrorDialog} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
